/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Discussion/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import FeatureFlag from 'DesignSystem/FeatureFlag/react'
import React from 'react'
import TysiaIconChat from 'DesignSystem/Svgs/TysiaIconChat/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Discussion({
  children,
  viewPath = "/DesignSystem/PatientComms/PatientCommsContactMethods/Content/Item/Discussion",
  isSubmitting
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let globalCurrentLocationParentCompanyIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.parent_company.id',
})
let contactMethodsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'contact_methods',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting,
  isHovered
  
})
  return (<React.Fragment
>
<FeatureFlag
  viewPath={`${viewPath}/FeatureFlag`}
 name="admin.patient.discussion.enabled"
 data="global.current_location.parent_company.id"
 organization_ids={globalCurrentLocationParentCompanyIdValueData}
 support={false}
>
{childProps => (
<div
  data-testid="Discussion.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<button
  data-testid="Discussion.Horizontal:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 disabled={contactMethodsIsSubmittingData}
 style={{'--pt-1-Z1Sa2B0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-Z1Sa2B0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-3-Z1Sa2B0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-4-Z1Sa2B0': childProps.isHovered ? dtColorsNeutral100 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconChat
  viewPath={`${viewPath}/TysiaIconChat`}
 width={14}
 height={14}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight={childProps.isHovered ? "semibold" : "normal"}
 text="Discussion"
/>
</button>
</div>
)}
</FeatureFlag>
{children}
</React.Fragment>)
}